/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { ActionContext, ActionTree } from "vuex";
import { IUserState } from "./state";
import { IRootState } from "@/store/modules/root/state";
import { IMutations } from "./mutations";
import { UserStore } from "@/store/constants";
import { User } from "firebase/auth";
import { getFirestore, getDoc, doc } from "firebase/firestore";
import { IUser } from "@chatcaptain/types/organization";

export enum Actions {
  SIGN_IN = "SIGN_IN",
  SIGN_OUT = "SIGN_OUT"
}

export type AugmentedActionContext = {
  commit<K extends keyof IMutations>(
    key: K,
    payload: Parameters<IMutations[K]>[1]
  ): ReturnType<IMutations[K]>;
} & Omit<ActionContext<IUserState, IRootState>, "commit">;

export interface IActions {
  [Actions.SIGN_IN]({ commit }: AugmentedActionContext, payload: User): void;
  [Actions.SIGN_OUT]({ commit }: AugmentedActionContext): void;
}

export const actions: ActionTree<IUserState, IRootState> & IActions = {
  [Actions.SIGN_IN]({ commit }, user: User) {
    user.getIdToken(true).then(idToken => {
      commit(UserStore.Mutations.SET_ID_TOKEN, idToken);
    });
    getDoc(doc(getFirestore(), "users/" + user.uid)).then(userDoc => {
      interface IUserData {
        root_organization?: string;
        displayName?: string;
        email: string;
      }
      const userData = userDoc.data() as IUserData;
      if(userData.root_organization) commit(UserStore.Mutations.SET_ORGANIZATION, userData.root_organization);
    });
    commit(UserStore.Mutations.SIGN_IN, user);
  },
  [Actions.SIGN_OUT]({ commit }) {
    commit(UserStore.Mutations.SIGN_OUT, undefined);
  }
}